import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import { SELECT_DELINEATION } from '../analytics.constants';
import { delineationByIdSelector } from '../../delineation/selectors/delineation.selectors';

export const trackSelectDelineation =
  (delineationId: number, analyticsEventTrack = track): AppThunk =>
  (_, getState) => {
    const selectedDelineation = delineationByIdSelector(delineationId)(
      getState(),
    );
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null || selectedDelineation == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsEventTrack({
      name: SELECT_DELINEATION,
      properties: {
        user_id: userId,
        ecg_id: ecgId,
        view,
        displayed_delineation: selectedDelineation.expertName,
      },
    });
  };
